import React from 'react';
import warningIcon from './images/warningIcon.png';

const ConfirmUploadDialog = ({ isOpen, uploadIssues, onConfirm, onCancel, t, tPlural, formatCount, haptic }) => {
  if (!isOpen) return null;

  const generateErrorMessages = () => {
    const { noDatePhotos = 0, photosTakenBefore = 0, photosTakenAfter = 0, screenshots = 0, formattedStartDate, formattedEndDate } = uploadIssues;
    const errors = [];
    
    // Show screenshots first
    if (screenshots > 0) {
      const message = tPlural('upload.screenshotIncluded', screenshots, {
        count: formatCount(screenshots)
      });
      errors.push(message);
    }
    
    if (noDatePhotos > 0) {
      const message = tPlural('upload.noDate', noDatePhotos, {
        count: formatCount(noDatePhotos)
      });
      errors.push(message);
    }
    
    if (photosTakenBefore > 0) {
      const message = tPlural('upload.beforeDate', photosTakenBefore, {
        count: formatCount(photosTakenBefore),
        date: formattedStartDate
      });
      errors.push(message);
    }
    
    if (photosTakenAfter > 0) {
      const message = tPlural('upload.afterDate', photosTakenAfter, {
        count: formatCount(photosTakenAfter),
        date: formattedEndDate
      });
      errors.push(message);
    }
    
    return errors;
  };

  const errors = generateErrorMessages();

  return (
    <div className="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
      <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
      <div className="fixed inset-0 z-10 flex items-center justify-center">
        <div 
          className="relative transform overflow-hidden bg-gradient-to-b from-theme-gradient-translucent-top to-theme-gradient-translucent-bottom p-[1px] transition-all duration-400 ease-out w-80 max-w-sm mx-4 rounded-3xl"
          style={{
            animation: isOpen ? 'dialogAppear 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards' : 'dialogDisappear 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards'
          }}
        >
          <div 
            className="w-full overflow-hidden text-left rounded-3xl shadow-2xl"
            style={{
              background: 'linear-gradient(to bottom, #FCFCFE, #E5E5F0)'
            }}
          >
            <div className="pt-6 px-6">
              <h3 className="font-satoshi font-bold text-black text-base text-left mb-3">
                {t('upload.confirmSubmitTitle')}
              </h3>
              
              <div className={errors.length > 0 ? 'mb-8' : ''}>
                {errors.length === 1 ? (
                  <p 
                    className="font-satoshi font-medium text-black text-base text-left" 
                  >
                    {errors[0]}
                  </p>
                ) : (
                  <div className="flex flex-col space-y-3">
                    {errors.map((error, index) => (
                      <div key={index} className="flex items-start">
                        <img src={warningIcon} alt={t('common.warningAlt')} className="w-[14px] h-[18px] mr-[9px] pt-[1px]" />
                        <p className="font-satoshi font-medium text-black text-base text-left">
                          {error}
                        </p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            
            <div className="flex justify-center px-4 pb-4 gap-4">
              <div className="flex-1 hover:opacity-70 active:opacity-70 transition-opacity">
                <button
                  type="button"
                  className="w-full flex justify-center items-center rounded-full font-satoshi font-bold text-base text-black h-12"
                  style={{
                    backgroundColor: '#D7D7E0',
                  }}
                  onClick={() => { haptic(); onCancel(); }}
                >
                  {t('common.no')}
                </button>
              </div>
              
              <div className="flex-1 bg-gradient-to-b from-theme-gradient-purple-top to-theme-gradient-purple-bottom p-[1px] rounded-full hover:opacity-70 active:opacity-70 transition-opacity">
                <button
                  type="button"
                  className="w-full flex justify-center items-center rounded-full font-satoshi font-bold text-base text-theme-white-100 bg-theme-purple-fill h-12"
                  onClick={() => { haptic(); onConfirm(); }}
                >
                  {t('common.yes')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <style>{`
        @keyframes dialogAppear {
          from {
            transform: translateY(96pt) scale(0.8);
            opacity: 0;
          }
          to {
            transform: translateY(0) scale(1.0);
            opacity: 1;
          }
        }
        
        @keyframes dialogDisappear {
          from {
            transform: translateY(0) scale(1.0);
            opacity: 1;
          }
          to {
            transform: translateY(96pt) scale(0.8);
            opacity: 0;
          }
        }
      `}</style>
    </div>
  );
};

export default ConfirmUploadDialog;
